<div class="searcher">
	<div class="row">
		<div class="term">
			<input class="typeahead autofocus typeahead-find search-input search-input-for" type="search" id="searchFor" value="{{searchModel.searchFor}}" [(ngModel)]="searchModel.searchFor"
				   placeholder="What are you looking for.. (Dentists, Pet Supplies etc)" (keyup)="onKeyupSearchInput($event)">
			<a href="#" class="close-search"></a>
		</div>
		<div class="location">
			<input class="typeahead typeahead-in search-input search-input-in" id="searchNear" type="search" value="{{searchModel.searchIn}}" [(ngModel)]="searchModel.searchIn"
				   placeholder="Where do you want to search?" (keyup)="onKeyupSearchInput($event)">
			<a href="#" class="close-search"></a>
		</div>
		<button class="btn primary btn-search" (click)="onDoSearch()" (keyup)="onKeyupSearchInput($event)">Search</button>
	</div>
	<div class="row">
		<a onClick="gotoAvailable(0,'')" class="sm-link">Explore Rankipedia's current list of professions</a>
	</div>
</div>
